import { http } from '@/api/client/httpClient';
import type { SigmaDataDto, SigmaFilterInput } from '@/api/types/sigma';

const BASE = '/api/app/sigma';

export const sigmaApi = {
  getSigmaData: (input: SigmaFilterInput) => http.get<SigmaDataDto>(`${BASE}/sigma-data`, { params: input }).then((r) => r.data),
  exportToExcelUrl: `${BASE}/export-to-excel`,
};
